/* eslint-disable */

import React, { Component } from 'react';
import _ from 'lodash';
import shortid from 'short-id';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { Button, Accordion, Dropdown, Grid, Divider } from 'semantic-ui-react';

import PreviewAccordionItem from './AdImportComponents/PreviewAccordionItem';
import SharePresentationEmail from './AdImportComponents/SharePresentationEmail';
import { Loader } from '../../components/share';
import { getTags } from '../../services/TagService';
import { getAdImports } from '../../services/AdServiceManager';

import * as AppActions from '../../actions';

const Container = styled.div`
  max-width: 100%;
`;
const Title = styled.h1`
  margin-bottom: 20px;
  color: #111;
`;
const Center = styled.div`
  height: 100%;
  margin-top: 30px;
`;
const IframeContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const IframeView = styled.iframe`
  width: ${(props) => `${props.width}px !important`};
  height: ${(props) => `${props.height}px !important`};
`;

class AdImportPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: null,
      loading: false,
      previews: [],
      minWidth: 1,
      minHeight: 400,
      selectedTags: {},
      oem: [],
      account: [],
      product: [],
      selectedAds: [],
      showCheckboxes: false
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.getTagsOptions();
    this.getAdImports(null);
  }

  getTagsOptions = async () => {
    const result = await getTags();
    const tags = _.sortBy(result.tags, 'value');
    tags.map((tag, index) => {
      if (this.state[tag.category])
        this.state[tag.category].push({
          key: index,
          value: tag.id,
          text: tag.value,
          category: tag.category
        });
    });
  };

  getAdImports = async (metadata) => {
    this.setState({ loading: true });
    const result = await getAdImports(metadata);
    const _previews = result.statusCode === 500 ? [] : result.data;
    const previews = _previews.map((prev) => {
      const _prev = prev;
      _prev.product = prev.product === '' ? null : prev.product;
      _prev.client = prev.client === '' ? null : prev.client;
      _prev.oem = prev.oem === '' ? null : prev.oem;
      return _prev;
    });
    const selectedAds = [];
    this.setState({ selectedAds, previews }, () => {
      setTimeout(() => {
        this.setState({ loading: false });
      }, 250);
    });
  };

  selectAllAdImports = async (metadata) => {
    const previews = this.state.previews;
    const selectedAds = previews.map((prev) => ({
      id: prev.id,
      name: prev.title,
      html_url: prev.html_url,
      html_width: prev.html_width,
      html_height: prev.html_height
    }));
    this.setState({ selectedAds, previews });
    this.setState({ selectedAds, previews }, () => {
      setTimeout(() => {
        this.setState({ loading: false });
      }, 250);
    });
  };

  deselectAllAdImports() {
    this.setState({ selectedAds: [] });
  }

  disableSelectButtons() {
    return !this.state.showCheckboxes;
  }

  updateSelectAds() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false });
    }, 250);
  }

  onTagSelect = (e, data) => {
    const tag = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    if (!tag) {
      return;
    }

    let selectedTags = this.state.selectedTags;
    selectedTags[tag.category] = tag.value;

    this.setState({ selectedTags });
  };

  onTagsSelect = (e, data) => {
    const tags = [];
    data.value.map((val) => {
      const tag = _.find(data.options, (option) => {
        return option.value === val;
      });

      if (tag) {
        tags.push(tag);
      }
    });
    let selectedTags = this.state.selectedTags;
    selectedTags[data.id] = data.value;

    this.setState({ selectedTags });
  };

  handleAccordionClick = (index) => {
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  handleShowCheckboxes = () => {
    this.setState({ showCheckboxes: !this.state.showCheckboxes });
  };

  handleSelectAd = (selectedAds) => {
    this.setState({ selectedAds });
  };

  onSubmit = () => {
    const payload = {
      product: this.state.selectedTags['product'],
      client: this.state.selectedTags['account'],
      oem: this.state.selectedTags['oem']
    };

    let metadata = '';
    if (payload.product || payload.client || payload.oem) {
      metadata += '?';
    }

    if (payload.oem) {
      metadata += `oem=${payload.oem}&`;
    }

    if (payload.client) {
      metadata += `client=${payload.client}&`;
    }

    if (payload.product) {
      metadata += `product=${payload.product}`;
    }

    this.getAdImports(metadata);
  };

  onClear = () => {
    this.setState({
      selectedTags: {}
    });
  };

  renderIframe = (url, width, height) => (
    <IframeContainer className="iframe-import-ad">
      <IframeView src={url} scrolling="no" width={width} height={height} />
    </IframeContainer>
  );

  renderAccordion = () => {
    if (this.state.loading) {
      return <Loader inverted active />;
    }

    const optionsTags = {
      account: this.state.account,
      product: this.state.product,
      oem: this.state.oem
    };

    return (
      <Center>
        <div>
          <Accordion fluid styled>
            {this.state.previews.map((preview, index) => (
              <PreviewAccordionItem
                key={shortid.generate()}
                adPreview={preview}
                optionsTags={optionsTags}
                activeIndex={this.state.activeIndex}
                index={index}
                selectedAds={this.state.selectedAds}
                showCheckboxes={this.state.showCheckboxes}
                handleAccordionClick={this.handleAccordionClick}
                handleSelectAd={this.handleSelectAd}
                renderIframe={this.renderIframe}
                actions={this.props.actions}
                getAdImports={this.onSubmit}
                editing
              />
            ))}
          </Accordion>
        </div>
      </Center>
    );
  };

  renderFilters = () => {
    return (
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column>
            <Dropdown
              search
              selection
              id="account"
              value={this.state.selectedTags['account']}
              options={this.state.account}
              placeholder="Client"
              onChange={this.onTagSelect}
            />
            <Divider hidden />
            <Dropdown
              search
              selection
              multiple
              id="product"
              value={
                this.state.selectedTags['product']
                  ? this.state.selectedTags['product']
                  : []
              }
              options={this.state.product}
              placeholder="Product"
              onChange={this.onTagsSelect}
            />
            <Divider hidden />
            <Dropdown
              search
              selection
              id="oem"
              value={this.state.selectedTags['oem']}
              options={this.state.oem}
              placeholder="OEM"
              onChange={this.onTagSelect}
            />
            <Divider hidden />
            <Button secondary width={3} onClick={this.onSubmit}>
              Filter
            </Button>
            <Button secondary width={3} onClick={this.onClear}>
              Clear
            </Button>
            <Divider hidden />
            <Button
              color="orange"
              onClick={() => this.selectAllAdImports()}
              disabled={this.disableSelectButtons()}
            >
              Select All
            </Button>
            <Button
              color="yellow"
              onClick={() => this.deselectAllAdImports()}
              disabled={this.disableSelectButtons()}
            >
              Deselect All
            </Button>
            <Button
              color="green"
              onClick={() => this.updateSelectAds()}
              disabled={
                this.disableSelectButtons() ||
                this.state.selectedAds.length == 0
              }
            >
              Confirm Selection
            </Button>
          </Grid.Column>
          <Grid.Column>
            {!this.state.loading ? (
              <SharePresentationEmail
                selectedAds={this.state.selectedAds}
                showCheckboxes={this.state.showCheckboxes}
                handleShowCheckboxes={this.handleShowCheckboxes}
              />
            ) : null}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  render() {
    return (
      <Container className="container ad-import-container">
        <Title>Display Ad Preview</Title>
        {this.renderFilters()}
        {this.renderAccordion()}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  adImport: state.adImport
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AdImportPreview);



// WEBPACK FOOTER //
// ./src/screens/AdImport/AdImportPreview.js